import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gruppi-utenti',
  templateUrl: './gruppi-utenti.component.html',
  styleUrls: ['./gruppi-utenti.component.scss']
})
export class GruppiUtentiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
